export enum FilterKeys {
  PeosTableCVStaff = 'PeosTableCVStaff',
  PeoPayrollProvidersTableCVStaff = 'PeoPayrollProvidersTableCVStaff',
  VerifiersBillingTable = 'VerifiersBillingTable',
  EmployersBillingTable = 'EmployersBillingTable',
}
